import styled from 'styled-components/macro';
import { colorCoreBlack900Base } from '../../../common/tokens/colors';
export const FooterContainerStyled = styled.footer `
  width: 100%;

  background-color: ${colorCoreBlack900Base};
`;
